import { render, staticRenderFns } from "./lighttest.vue?vue&type=template&id=bdaf0452&scoped=true&"
import script from "./lighttest.vue?vue&type=script&lang=js&"
export * from "./lighttest.vue?vue&type=script&lang=js&"
import style0 from "./lighttest.vue?vue&type=style&index=0&id=bdaf0452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf0452",
  null
  
)

export default component.exports